import { render, staticRenderFns } from "./DgTree.vue?vue&type=template&id=0e5eb2a2&"
import script from "./DgTree.vue?vue&type=script&lang=js&"
export * from "./DgTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_a2ryrgrddytsl2onh2hza74dqa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\comm\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5eb2a2')) {
      api.createRecord('0e5eb2a2', component.options)
    } else {
      api.reload('0e5eb2a2', component.options)
    }
    module.hot.accept("./DgTree.vue?vue&type=template&id=0e5eb2a2&", function () {
      api.rerender('0e5eb2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/dg-contextmenu/src/DgTree.vue"
export default component.exports